import { Dispatch } from 'redux';
import { userType } from '../Type/Type';
import {UserAPI, followAPI} from '../api/api.ts'
import { InferActionTypes, RootState } from './redux-store';
import { ThunkAction } from 'redux-thunk';

const FOLLOW = 'FOLLOW';
const UNFOLLOW = 'UNFOLLOW';
const SET_USERS = 'SET_USERS';
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'
const TOGGEL_IS_FETCHING = 'TOGGEL_IS_FETCHING'
const FOLLOWING_IS_PROGRES = 'FOLLOWING_IS_PROGRES'

let initialState = {
    users: [] as Array<userType>,
    pageSize: 50,
    totalUsersCount: 100,
    currentPage: 1,
    isFetching: true,
    followingIsProgres: [] as Array<number>,
}

export type initialStateType = typeof initialState

const usersReducer = (state = initialState, action: ActionTypes ): initialStateType => {
    switch(action.type) {
        case FOLLOW:{
            return {
                ...state,
                users: state.users.map( u => {
                    if (u.id === action.usersId) {
                        return {...u, follow: true}
                    }
                    return u;
                })
            }
        }

            case UNFOLLOW: {
                return {
                    ...state,
                    users: state.users.map( u => {
                        if(u.id === action.usersId) {
                            return {...u, follow: false}
                        }
                        return u;
                    })
                }
            }

            case SET_USERS: {
                return { ...state, users: action.users}
            }
            case SET_CURRENT_PAGE: {
                return { ...state, currentPage: action.currentPage}
            }
            case SET_TOTAL_COUNT: {
                return { ...state, totalUsersCount: action.count}
            }
            case TOGGEL_IS_FETCHING: {
                return { ...state, isFetching: action.isFetching}
            }
            case FOLLOWING_IS_PROGRES: {
                return { 
                    ...state, 
                    followingIsProgres: action.isFetching 
                    ? [...state.followingIsProgres, action.userId]
                    : state.followingIsProgres.filter(id => id !== action.userId)
                }
            }
            default: 
            return state;
        
    }
}
type ActionTypes = InferActionTypes<typeof actions>

export const actions = {
 followSuccess: (usersId: number) => ({type: FOLLOW, usersId} as const),
 unfollowSuccess: (usersId: number) => ({type: UNFOLLOW, usersId} as const),
 setUsers: (users: Array<userType>)  => ({type: SET_USERS, users} as const),
 setCurrentPage: (currentPage: number)  => ({type: SET_CURRENT_PAGE, currentPage} as const),
 setTotalUsersCount: (totalUsersCount: number) => ({type: SET_TOTAL_COUNT, count: totalUsersCount} as const),
 toggeleIsFetching: (isFetching: boolean) => ({type: TOGGEL_IS_FETCHING, isFetching} as const),
 followingProgres: (isFetching: boolean, userId: number) => ({type: FOLLOWING_IS_PROGRES, isFetching, userId} as const),
}

type GetStateType = () => RootState
type DispatchType = Dispatch<ActionTypes>
type ThunkType = ThunkAction<Promise<void>, RootState, unknown, ActionTypes>

export const getUsersThunkCreator = (currentPage: number, pageSize: number): ThunkType => async (dispatch, getState) => {
    dispatch(actions.toggeleIsFetching(true));
    dispatch(actions.setCurrentPage(currentPage));

    let data = await UserAPI.getUsers(currentPage, pageSize)
    dispatch(actions.setCurrentPage(currentPage));
    dispatch(actions.toggeleIsFetching(false));
    dispatch(actions.setUsers(data.items));
    dispatch(actions.setTotalUsersCount(data.totalCount));
}

const _followUnFollowFllow = async (dispatch: DispatchType, userId: number ,apiMethod: any, actionCreator: (userId: number) => any) => {
    dispatch(actions.followingProgres(true, userId));
    let data = await apiMethod(userId)
    if (data.resultCode == 0) {
        dispatch(actionCreator(userId));
    };
    dispatch(actions.followingProgres(false, userId));
}

export const follow = (userId: number): ThunkType => async (dispatch) => {

    _followUnFollowFllow(dispatch, userId, followAPI.follow.bind(followAPI), actions.followSuccess)
}

export const unfollow = (userId: number): ThunkType => async (dispatch) => {
    _followUnFollowFllow(dispatch, userId, followAPI.unfollow.bind(followAPI), actions.unfollowSuccess);
}

export default usersReducer;